import Plot2D from '../../../Result/Public/waveform/Plot2D';
class BathtubPlot {
  constructor() {
    this.plot = null;
    this.curves = {};
  }

  getCurves() {
    if (this.plot && this.plot.curves) {
      return this.plot.curves;
    }
  }

  getCurvesList(type) {
    if (type) {
      return this.curves && this.curves[type] ? this.curves[type] : [];
    }

    const resCurves = [];
    for (const key in this.curves) {
      if (this.curves.hasOwnProperty(key)) {
        const curves = this.curves[key];
        resCurves.push(...curves);
      }
    }

    return resCurves;
  }

  setCurves(curves) {
    if (curves && curves.length > 0) {
      this.plot.plotCurves(curves, false);
      this.plot.redrawPlot(this.plot.svgElement);
    }
  }

  generateCurve = (bathtub, id) => {
    const { CurveItem } = Plot2D;
    const { signals = [], times, curveData, historyTime } = bathtub;
    // prepare the curve data
    let curves = [];
    for (let i = 0; i < signals.length; i++) {
      const signal = signals[i];
      if (signal.name) {
        let newCurve = new CurveItem();
        newCurve.x = times[i];
        newCurve.y = curveData[i];
        newCurve.name = [id, signal.name].join('::');
        newCurve.time = historyTime;
        newCurve.curveId = `${historyTime}-${i}`;
        newCurve.curveIndex = i;
        newCurve.id = id;
        newCurve.rowName = signal.rowName;
        curves.push(newCurve);
      }
    }

    return curves;
  }

  plotBathtub = ({ svgElement, ui = 1e-9, events, bathtub, axis, id = null, type }) => {
    if (this.plot === null) {
      const { PlotOptions } = Plot2D;
      // plot options
      const plotOptions = new PlotOptions();
      plotOptions.xUnit = axis.xUnit || 's';
      plotOptions.yUnit = axis.yUnit;
      plotOptions.grid = 'xy';
      plotOptions.zoom = 'x';
      plotOptions.xLabel = axis.xLabel || 'Time';
      plotOptions.yLabel = axis.yLabel;
      plotOptions.ui = ui; //unit interval - approximate data cycle length
      this.plot = new Plot2D(svgElement, plotOptions, events, 'andes');
      this.plot.type = "andes";
    }

    const curves = this.generateCurve(bathtub, id);
    this.plot.plotCurves(curves, null, null, null, 1);
    this.curves[type] = this.plot.curves;
    return this.plot;
  } // plotBathtubPlot


  updataRawCurve = () => {
    this.plot.updatePlot();
  }

  cleanBathtubPlot = () => {
    this.plot = null;
  }
};

const bathtubPlot = new BathtubPlot();
export default bathtubPlot;
export { BathtubPlot }